import { useKeycloak } from "@react-keycloak/web";
import { useEffect } from "react";
import Loader from "../components/element/Loader";
import { useLogout } from "../services/LogoutProvider";

const PrivateRoute = ({ component: Component }) => {
  const { keycloak, initialized } = useKeycloak();
  const { handleSessionExpired, isSessionExpired } = useLogout();

  useEffect(() => {
    const checkSession = () => {
      if (initialized && !keycloak.authenticated && keycloak.token) {
        handleSessionExpired();
      } else if (initialized && !keycloak.authenticated && !isSessionExpired) {
        keycloak.login();
      }
    };

    checkSession();
  }, [keycloak, initialized, handleSessionExpired, isSessionExpired]);

  if (!initialized) {
    return (
      <div className="loader-center-align-container">
        <Loader />
      </div>
    );
  }

  if (!keycloak.authenticated) {
    return null;
  }
  return <Component />;
};

export default PrivateRoute;
